import React from 'react';
import PidDiagramShell, { PidPipe, PidPort } from './PidDiagramShell';
import { PulpPaperRoute } from '../../types';

/** 卫生纸机 P&ID 详细图：单流浆箱 → 圆网成型 → 大烘缸 → 起皱 → 卷取 */
const media = {
  pulp: { label: '浆料', light: '#ef6c00', dark: '#ffb74d', width: 2.6 },
  paper: { label: '纸页', light: '#6d4c41', dark: '#a1887f', width: 2.6 },
  steam: { label: '干燥蒸汽', light: '#d32f2f', dark: '#e57373', width: 2 },
  water: { label: '白水 / 冷凝水', light: '#1565c0', dark: '#64b5f6', width: 2 },
};

const devices = [
  { id: 'sb', kind: 'hDrum' as const, x: 170, y: 189, tag: 'SB-101', name: '流浆箱' },
  { id: 'wb', kind: 'washer' as const, x: 380, y: 188, tag: 'WB-101', name: '圆网成型' },
  { id: 'yy', kind: 'exchanger' as const, x: 540, y: 181, tag: 'YY-101', name: '杨克大烘缸', note: '单缸干燥' },
  { id: 'cr', kind: 'washer' as const, x: 720, y: 188, tag: 'CR-101', name: '起皱刮刀' },
  { id: 'rd', kind: 'hDrum' as const, x: 870, y: 189, tag: 'RD-101', name: '卷取' },
];

const ports: PidPort[] = [
  { id: 'p-pulp', label: '卫生纸浆', medium: 'pulp', x: 0, y: 224, direction: 'in' as const },
  { id: 'p-stm', label: '干燥蒸汽', medium: 'steam', x: 500, y: 40, direction: 'in' as const },
  { id: 'p-paper', label: '成品纸卷', medium: 'paper', x: 1040, y: 224, direction: 'out' as const },
  { id: 'p-white', label: '白水回收', medium: 'water', x: 290, y: 611, direction: 'out' as const },
  { id: 'p-cond', label: '凝结水', medium: 'water', x: 640, y: 470, direction: 'out' as const },
];

const pipes: PidPipe[] = [
  { id: 'k01', from: 'p-pulp', fromSide: 'right', to: 'sb', toSide: 'left', medium: 'pulp' },
  { id: 'k02', from: 'sb', fromSide: 'right', to: 'wb', toSide: 'left', medium: 'pulp' },
  { id: 'k03', from: 'wb', fromSide: 'right', to: 'yy', toSide: 'left', medium: 'paper' },
  { id: 'k04', from: 'yy', fromSide: 'right', to: 'cr', toSide: 'left', medium: 'paper' },
  { id: 'k05', from: 'cr', fromSide: 'right', to: 'rd', toSide: 'left', medium: 'paper' },
  { id: 'k06', from: 'rd', fromSide: 'right', to: 'p-paper', toSide: 'left', medium: 'paper' },
  { id: 'k07', from: 'p-stm', fromSide: 'right', to: 'yy', toSide: 'top', medium: 'steam' },
  { id: 'k08', from: 'yy', fromSide: 'bottom', to: 'p-cond', toSide: 'left', medium: 'water' },
  { id: 'k09', from: 'wb', fromSide: 'bottom', to: 'p-white', toSide: 'left', medium: 'water' },
];

const TissuePaperDiagram: React.FC<{ route: PulpPaperRoute }> = ({ route }) => (
  <PidDiagramShell
    routeName={route.name}
    title="卫生纸机详细流程"
    subtitle="流浆箱 → 圆网成型 → 杨克大烘缸（单缸干燥，蒸汽加热）→ 起皱刮刀 → 卷取，纸面柔软起皱（设备形状按 P&ID 惯例，管线按介质分色）"
    media={media}
    devices={devices}
    ports={ports}
    pipes={pipes}
    feedstock={route.feedstock}
    products={route.products}
  />
);

export default TissuePaperDiagram;
